/* @flow strict */

import * as React from 'react';
import { Link } from 'react-router-dom';
import Switcher from '../../components/switcher';
import CssPinner from '../../components/csspinner';
import { PUT } from '../../api';

type PropsType = {
  img: string,
  imgAlt: string,
  title: string,
  descr: string,
  href?: string,
  link?: string,
  linkTarget?: string,
  switch?: string,
  featureStatus?: boolean,
  handleGetProfile?: any
};

const IntegrationsItem = (props: PropsType): React.Element<typeof React.Fragment> => {
  return (
    <div className="sparxo-integrations-item">
      <div className="media">
        <div className="media-left">
          <img className="media-object" src={props.img} alt={props.imgAlt} />
        </div>

        <div className="media-body">
          <div className="row">
          <div className="col-sm-8 col-md-9">
            <h4 className="media-heading">{props.title}</h4>
            <span>{props.descr}</span>
          </div>
          <div className="col-sm-4 col-md-3">
            {!!props.switch ?
              <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '60px'
              }}
              >
                <Switcher
                  className='form-switcher-lg'
                  id={props.switch}
                  name={props.switch}
                  index={props.switch}
                  checked={props.featureStatus}
                  onCallback={async (e: any, newStatus: boolean) => {
                    CssPinner(document.querySelector('body'), true);
                    try {
                      await PUT(
                        `/api/v1/1/merchants/${props.switch}`,
                        {
                          [`is_enable_${props.switch}`]: newStatus
                          }
                      );
                      await props.handleGetProfile();
                      CssPinner(document.querySelector('body'), false);
                    } catch (error) {
                      CssPinner(document.querySelector('body'), false);
                    }
                  }}
                />
              </div>
            :
              <Link to={props.href} target={props.linkTarget} className="btn btn-pink"> {props.link} </Link>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
  );
};

export default IntegrationsItem;
